<div class="relative">
    @if(formControlItem){
        <div>
            @if(label){
                <label [for]="id" class="block text-normal text-sm font-medium leading-6">{{label | translate}}</label>
            }
            <div class="relative mt-2 rounded-md shadow-sm">
            <textarea [formControl]="formControlItem"
                [id]="id"
                class="
                 text-normal font-medium p-3 text-16 border-none ring-gray-300
                 focus:ring-inset focus:ring-transparent leading-6 bg-transparent
                block pl-2 w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset focus:ring-2
                sm:text-sm sm:leading-6"
                [placeholder]="(placeholder || '') | translate"
                      [maxlength]="maxSymbols || 5000"
                [rows]="rows" [name]="name" ></textarea>
                @if(formControlItem.invalid  && (formControlItem.dirty || formControlItem.touched)){
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                        </svg>
                    </div>
                }
            </div>
            @if(formControlItem.invalid) {
                <app-validation-error [control]='formControlItem' class="text-red-500 text-xs italic"></app-validation-error>
            }

        </div>
    } @else {
        <div>
            @if(label){
                <label [for]="id" class="block text-normal text-sm font-medium leading-6">{{label}}</label>
            }
            <div class="relative mt-2 rounded-md shadow-sm">
      <textarea [id]="id"
                [value]="value"
                (input)="valueChange($event)"
                (blur)="onBlur()"
                class="
                 text-normal font-medium p-3 text-16 border-none ring-gray-300
                 focus:ring-inset focus:ring-transparent leading-6 bg-transparent
                block pl-2 w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset focus:ring-2
                sm:text-sm sm:leading-6"
                [placeholder]="placeholder"
                [rows]="rows"
                [name]="name"
      ></textarea>
            </div>
        </div>
    }
    @if(maxSymbols){
        <span class="text-gray-500 absolute bottom-2 right-2 text-sm">{{value?.length || formControlItem.value.length}} / {{maxSymbols}}</span>
    }
</div>
